import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ani-lang") || "en");

  useEffect(() => {
    localStorage.setItem("ani-lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = useCallback(
    (path) => {
      const segs = path.split(".");
      let cur = translations[lang];
      for (const s of segs) cur = cur?.[s];
      if (cur === undefined) {
        cur = translations.en;
        for (const s of segs) cur = cur?.[s];
      }
      return cur ?? path;
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t, isAr: lang === "ar" }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLanguage = () => useContext(LangContext);
